module.exports = __webpack_public_path__ + "img/egressos-modelo2.bc058d12.png";